'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pubsub = require('../../pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _inputField = require('./input-field.scss');

var _inputField2 = _interopRequireDefault(_inputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputField = function (_React$Component) {
    _inherits(InputField, _React$Component);

    function InputField(props) {
        _classCallCheck(this, InputField);

        var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));

        _this.state = {
            isBadgeActive: false
        };

        _this.onMouseover = _this.onMouseover.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        return _this;
    }

    _createClass(InputField, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.showBadge) {
                this.badgeEventId = _pubsub2.default.on('input.badge-select', function (badgeName) {
                    if (badgeName !== _this2.props.name) {
                        _this2.setState({
                            isBadgeActive: false
                        });
                    }
                });

                this.graphEventId = _pubsub2.default.on('graph-display.nav-click', function () {
                    _this2.setState({
                        isBadgeActive: false
                    });
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            // Remove subscriptions
            if (this.badgeEventId) {
                _pubsub2.default.off(this.badgeEventId);
            }

            if (this.graphEventId) {
                _pubsub2.default.off(this.graphEventId);
            }
        }
    }, {
        key: 'activateBadge',
        value: function activateBadge() {
            var _this3 = this;

            if (this.badgeEventId !== undefined) {
                this.setState({
                    isBadgeActive: true
                }, function () {
                    _pubsub2.default.trigger('input.badge-select', _this3.props.name);
                });
            }
        }
    }, {
        key: 'onMouseover',
        value: function onMouseover(e) {
            this.activateBadge();
        }
    }, {
        key: 'onFocus',
        value: function onFocus(e) {
            this.activateBadge();
        }
    }, {
        key: 'render',
        value: function render() {
            var inputClasses = _inputField2.default["input-field"];

            if (this.props.disabled) {
                inputClasses += ' ' + _inputField2.default.disabled;
            }

            if (this.props.error) {
                inputClasses += ' ' + _inputField2.default.error;
            }

            return _react2.default.createElement(
                'label',
                { className: inputClasses },
                _react2.default.createElement(
                    'span',
                    { className: _inputField2.default["label-container"], 'data-equalize': true },
                    _react2.default.createElement(
                        'span',
                        { className: _inputField2.default.label },
                        this.props.label
                    ),
                    this.props.showBadge ? _react2.default.createElement(
                        'span',
                        {
                            className: _inputField2.default.badge + (this.state.isBadgeActive ? ' ' + _inputField2.default["is-active"] : ''),
                            onMouseOver: this.onMouseover },
                        this.props.name
                    ) : null
                ),
                _react2.default.createElement('input', {
                    onFocus: this.onFocus,
                    className: _inputField2.default.input,
                    id: this.props.id,
                    name: this.props.name,
                    value: this.props.value,
                    type: this.props.type,
                    placeholder: this.props.placeholder,
                    disabled: this.props.disabled,
                    onChange: this.props.change,
                    required: this.props.required,
                    min: this.props.min,
                    max: this.props.max }),
                _react2.default.createElement(
                    'span',
                    { className: _inputField2.default["error-message"] },
                    this.props.error ? this.props.error.label : ''
                )
            );
        }
    }]);

    return InputField;
}(_react2.default.Component);

InputField.propTypes = {
    change: _propTypes2.default.func,
    disabled: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    error: _propTypes2.default.object,
    id: _propTypes2.default.any,
    label: _propTypes2.default.string.isRequired,
    max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    name: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    required: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    type: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    showBadge: _propTypes2.default.bool
};

InputField.defaultProps = {
    type: 'text',
    showBadge: true
};

exports.default = InputField;


//////////////////
// WEBPACK FOOTER
// ./client/components/input-field/index.js
// module id = 126
// module chunks = 0